<h2 mat-dialog-title>Pointages — {{ data.employeeName }}</h2>

<mat-dialog-content [formGroup]="form">
	@for (c of sortedClocks; track c.id) {
		<div class="flexrow clock-row" [class.cancelled]="c.cancelled">
			<span>{{ clockLabel(c) }}</span>
			<span class="spacer"></span>
			@if (!c.cancelled) {
				<button mat-icon-button aria-label="Annuler ce pointage" matTooltip="Annuler (tracé, jamais supprimé)"
					(click)="onCancelClock(c)">
					<mat-icon>block</mat-icon>
				</button>
			}
		</div>
	}
	@if (data.clocks.length === 0) {
		<div class="empty">Aucun pointage sur la période.</div>
	}

	<mat-divider></mat-divider>

	<div class="add-title">Ajouter un pointage oublié (correction manuelle, tracée)</div>
	<div class="flexrow add-row">
		<mat-form-field>
			<mat-label>Date</mat-label>
			<input matInput [matDatepicker]="datPicker" formControlName="dat">
			<mat-datepicker-toggle matIconSuffix [for]="datPicker"></mat-datepicker-toggle>
			<mat-datepicker #datPicker></mat-datepicker>
		</mat-form-field>
		<mat-form-field class="time">
			<mat-label>Heure</mat-label>
			<input matInput type="time" formControlName="time">
		</mat-form-field>
		<mat-form-field class="io">
			<mat-label>Sens</mat-label>
			<mat-select formControlName="io">
				<mat-option [value]="1">Entrée</mat-option>
				<mat-option [value]="2">Sortie</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<mat-form-field class="full">
		<mat-label>Commentaire (motif de la correction / annulation)</mat-label>
		<input matInput formControlName="comment">
	</mat-form-field>

	@if (errorMessage) {
		<div class="error">{{ errorMessage }}</div>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onClose()">Fermer</button>
	<button mat-flat-button color="primary" type="button" (click)="onAdd()">
		<mat-icon>more_time</mat-icon>&nbsp;Ajouter le pointage
	</button>
</mat-dialog-actions>
